import styled from "styled-components";

export const ListContainer = styled.div`
    width: 100%;
    height: auto;

    gap: 16px;
    display: flex;
    flex-direction: column;
`;

export const Item = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 20px;

    > div {
        flex: 1 1 0;
        min-width: 0;
        max-width: 212px;
    }

    img {
        display: flex;
        position: relative;
        cursor: pointer;
        flex-shrink: 0;
    }
`;

export const TitleWrap = styled.div`
    width: 100%;

    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const Title = styled.h2`
    font-family: Lato;
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #303848;
    margin-bottom: 0px;
    opacity: ${props => (props.cancelada ? "0.35" : "1")};
    margin-top: 0px;

`;

export const Subtitle = styled.p`
    width: 100%;
    font-family: Lato;
    font-size: 12px;
    color: #586377;
    margin: 0px;
`;
